// extracted by mini-css-extract-plugin
export default {"insured_landing_page_wrapper":"InsuredLandingStyles_insured_landing_page_wrapper__Qld9M","insured_activity_container":"InsuredLandingStyles_insured_activity_container__dGYc-"};